import {Injectable} from "@angular/core";
import {RouteViewModel} from "../system/admin-panel/Routes/Model/RouteViewModel";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable()
export class RoutesService {

  constructor(private client:HttpClient) {

  }

  public GetRoutes() {
    return  this.client.get<any>("/ctrl/routes").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(RouteViewModel.fromJS(item))
      }

      return result;
    }));
  }

  public DeleteRoute(id) {
    return this.client.delete("/ctrl/routes/" + id);
  }
  public CreateRoute(model:RouteViewModel){
    return this.client.post("/ctrl/routes", model);
  }
  public EditRoute(model:RouteViewModel){
    return this.client.put("/ctrl/routes", model);
  }
}
